// export default function Header(){
//   return(
//     <>
//      <div className="bg-blue-800 text-white py-2 px-4 flex justify-between items-center">
//         <div className="flex items-center space-x-6">
//           <a href="mailto:info@ggasso.com" className="flex items-center space-x-2">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
//               <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
//               <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
//             </svg>
//             <span>info@cmadevangpatel.com</span>
//           </a>
//           {/* <a href="tel:+918849856022" className="flex items-center space-x-2">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
//               <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
//             </svg>
//             <span>+91 88498 56022</span>
//           </a> */}
//         </div>
//         <div className="flex items-center space-x-4">
//           <a href="#" aria-label="LinkedIn">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
//             </svg>
//           </a>
//           <a href="#" aria-label="Twitter">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.1 10.1 0 01-3.127 1.184 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
//             </svg>
//           </a>
//           <a href="#" aria-label="Facebook">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z"/>
//             </svg>
//           </a>
//         </div>
//       </div>

//       {/* Navigation Bar */}
//       <div className="bg-white py-4 px-6 border-b flex justify-between items-center">
//         <div className="flex items-center space-x-6">
//           <div className="flex items-center">
//             <div className="text-xl font-bold text-blue-800">Devang Patel & Associates</div>
            
//           </div>
//           {/* <div className="flex items-center">
//             <img src="/api/placeholder/100/50" alt="ICMA Logo" className="h-12" />
//           </div> */}
//         </div>
//         <nav className="hidden md:flex items-center space-x-8">
//           <a href="#" className="text-blue-800 font-semibold">Home</a>
         
//           <a href="#" className="text-gray-600 hover:text-blue-800">Services</a>
//           <a href="#" className="text-gray-600 hover:text-blue-800">About Us</a>
//           <a href="#" className="text-gray-600 hover:text-blue-800">Let's Connect</a>
//         </nav>
//         <div className="md:hidden">
//           <button className="text-gray-600">
//             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
//             </svg>
//           </button>
//         </div>
//       </div>

//     </>
//   )
// }
import { NavLink } from 'react-router-dom';
import logo1 from '../assets/cma.png'
import logo2 from '../assets/cmalogo1.png'
export default function Header() {
  return (
    <>
      <div className="bg-customBlueLight text-white py-2 px-4 flex justify-between items-center">
        <div className="flex items-center space-x-6">
          <a href="mailto:hello@cmadevangpatel.com" className="flex items-center space-x-2">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
            </svg>
            <span>hello@cmadevangpatel.com</span>
          </a>
        </div>
        {/* <div className="flex items-center space-x-4">
          <a href="#" aria-label="LinkedIn">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
            </svg>
          </a>
          <a href="#" aria-label="Twitter">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.1 10.1 0 01-3.127 1.184 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z"/>
            </svg>
          </a>
        </div> */}
      </div>

      {/* Navigation Bar */}
      <div className="bg-white py-4 px-6 border-b flex justify-between items-center">
        <div className="flex items-center space-x-6">
          <div className="flex items-center">
            {/* <div className="text-xl font-bold text-blue-800">Devang Patel & Associates</div> */}
         
            < img src={logo1} className=' h-5 md:h-10'/>

          </div>
        </div>
        <nav className="hidden md:flex items-center space-x-8">
          <NavLink 
            to="/" 
            className="text-gray-600 hover:text-blue-800" 
            activeClassName="text-blue-600 hover:text-blue-600"
            exact
          >
            Home
          </NavLink>
         
          <NavLink 
            to="/services" 
            className="text-gray-600 hover:text-blue-800" 
            activeClassName="text-blue-600 hover:text-blue-600"
          >
            Services
          </NavLink>

          <NavLink 
            to="/about" 
            className="text-gray-600 hover:text-blue-800" 
            activeClassName="text-blue-600 hover:text-blue-600"
          >
            About Us
          </NavLink>

          <NavLink 
            to="/contact" 
            className="text-gray-600 hover:text-blue-800" 
            activeClassName="text-blue-600 hover:text-blue-600"
          >
            Let's Connect
          </NavLink>
        </nav>

        <div className="md:hidden">
          <button className="text-gray-600">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
}
